<template>
  <div class="grid-view">
    <div class="main-content">
      <div style="width: 100%;" class="section">
        <div style="padding-top: 5px;">
          <el-button type="primary" @click="seachEventHandler">{{ $t('CargoMsg.Cargo_Query') }}</el-button>
          <el-button type="primary" @click="recipientEventHandler()">{{ $t('CargoMsg.Cargo_Acquisition') }}</el-button>
          <el-button type="primary" @click="invalidEventHandler()">{{ $t('CargoMsg.Cargo_Invalid') }}</el-button>
          <el-button type="primary" @click="restoreEventHandler()">{{ $t('CargoMsg.Cargo_Restore') }}</el-button>
          <el-button type="primary" @click="userEventHandker()">{{ $t('CargoMsg.Cargo_Use') }}</el-button>
        </div>

        <el-form label-width="60px" label-position="left" :inline="true" style="padding-top: 10px;">
          <el-row>
            <el-col :span="24">
              <el-form-item :label="$t('CargoMsg.Cargo_InvoiceNo')">
                <el-input v-model="filter.txtInoviceNo" style="width:150px;" />
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.Cargo_InvoiceType')">
                <el-select v-model="filter.invoiceType" style="width:150px;">
                  <el-option
                    v-for="(item,index) in InvoiceConstant.INVOICE_TYPES_HAS_ALL"
                    :key="index"
                    :label="language?item.chineseName:item.englishName"
                    :value="item.code"
                  />
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.Cargo_InvoiceStatus')">
                <el-select v-model="filter.invoiceState" style="width:150px;">
                  <el-option
                    v-for="(item,index) in InvoiceConstant.INVOICE_STATUS_HAS_ALL"
                    :key="index"
                    :label="language?item.chineseName:item.englishName"
                    :value="item.code"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item :label="$t('CargoMsg.Cargo_Acquirer')">
                <cargo-user-select
                  style="width:150px;"
                  :default-value="filter.autoRecipienter||''"
                  @change="p=>{filter.autoRecipienter = p.value}"
                />
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.Cargo_AcquisitionTime')">
                <el-date-picker v-model="filter.recipientingDateMin" :picker-options="recipientingDateMinPickerOptions" style="width:150px;" type="date" value-format="yyyy-MM-dd" @change="changeRecipientingDateMin" />&nbsp;{{ $t('CargoMsg.Cargo_To') }}
                <el-date-picker v-model="filter.recipientingDateMax" :picker-options="recipientingDateMaxPickerOptions" style="width:150px;" type="date" value-format="yyyy-MM-dd" @change="changeRecipientingDateMax" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item :label="$t('CargoMsg.Cargo_User')">
                <cargo-user-select
                  style="width:150px;"
                  :default-value="filter.autoUser||''"
                  @change="p=>{filter.autoUser = p.value}"
                />
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.Cargo_TimeOfUse')">
                <el-date-picker v-model="filter.usingDateMin" :picker-options="usingDateMinPickerOptions" style="width:150px;" type="date" value-format="yyyy-MM-dd" @change="changeUsingDateMin" />&nbsp;{{ $t('CargoMsg.Cargo_To') }}
                <el-date-picker v-model="filter.usingDateMax" :picker-options="usingDateMaxPickerOptions" style="width:150px;" type="date" value-format="yyyy-MM-dd" @change="changeUsingDateMax" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="section grid-wrapper" style="min-height:350px">
        <cargo-ag-grid
          key="1906064"
          config-module="1906064"
          :grid-params.sync="gridParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
          style="flex: 1"
          @gridReady="params=>{gridApi=params.api}"
        />
      </div>
    </div>

    <!-- 发票领用 弹窗 -->
    <el-dialog
      v-if="invoiceRecordsWindow.visible"
      v-el-drag-dialog
      :visible.sync="invoiceRecordsWindow.visible"
      :title="$t('CargoMsg.Cargo_InvoiceAcquisition')"
      width="350px"
      append-to-body
      :close-on-click-modal="false"
    >
      <div class="app-main-inner-row" style="justify-content: center;">
        <el-form label-width="100px" label-position="right">
          <el-form-item :label="$t('CargoMsg.Cargo_Acquirer')">
            <cargo-user-select
              ref="userAuto"
              :default-value="invoiceRecordsWindow.userAuto||''"
              @change="p=>{invoiceRecordsWindow.userAuto = p.value}"
            />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_AcquisitionTime')">
            <el-date-picker ref="recipientingDate" v-model="invoiceRecordsWindow.recipientingDate" type="date" value-format="yyyy-MM-dd" style="width: 100%;" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button type="primary" @click="okEventRecords">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
        <el-button @click="invoiceRecordsWindow.visible=false">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
      </span>
    </el-dialog>

    <!-- 发票使用 弹窗 -->
    <el-dialog
      v-if="invoiceUserWindow.visible"
      v-el-drag-dialog
      :visible.sync="invoiceUserWindow.visible"
      :title="$t('CargoMsg.Cargo_InvoiceUse')"
      width="350px"
      append-to-body
      :close-on-click-modal="false"
    >
      <div class="app-main-inner-row" style="justify-content: center;">
        <el-form label-width="100px" label-position="right">
          <el-form-item :label="$t('CargoMsg.Cargo_User')">
            <cargo-user-select
              ref="userAuto"
              :default-value="invoiceUserWindow.userAuto||''"
              @change="p=>{invoiceUserWindow.userAuto = p.value}"
            />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_TimeOfUse')">
            <el-date-picker ref="userDate" v-model="invoiceUserWindow.userDate" type="date" value-format="yyyy-MM-dd" style="width: 100%;" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button type="primary" @click="okEventUser">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
        <el-button @click="invoiceUserWindow.visible=false">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import * as InvoiceConstant from '@/class/cargo/model/parameters/InvoiceConstant'
import cargoUpDownResize from '@/components/Cargo/Common/cargoUpDownResize'
import URL from '@/api/urlTranslator'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getLoading } from '@/utils/utilBaseElement'
import { queryInvoiceNoByInvoiceNoManage, updateInvoiceNoFields, saveRecipientsInvoiceRecords } from '@/api/clearing/invoiceNo'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import { RecipientsInvoiceRecords } from '@/class/model/act/RecipientsInvoiceRecords'
import DateUtils from '@/utils/dateUtils'
import { recordSelectedStatus } from '@/utils/agGrid'

export default {
  name: 'InvoiceRecords',
  components: { cargoUpDownResize, cargoUserSelect },
  data() {
    return {
      recipientingDateMinPickerOptions: { // 设置可选时间范围
        disabledDate: this.disabledRecipientingDateMin
      },
      recipientingDateMaxPickerOptions: { // 设置可选时间范围
        disabledDate: this.disabledRecipientingDateMax
      },
      usingDateMinPickerOptions: { // 设置可选时间范围
        disabledDate: this.disabledUsingDateMin
      },
      usingDateMaxPickerOptions: { // 设置可选时间范围
        disabledDate: this.disabledUsingDateMax
      },
      URL,
      InvoiceConstant,
      selectedItem: null,
      selectTypeNames: TYPE_NAMES,
      filter: {
        txtInoviceNo: '',
        invoiceType: null,
        invoiceState: null,
        autoUser: '',
        recipientingDateMin: '',
        recipientingDateMax: '',
        usingDateMin: '',
        usingDateMax: '',
        autoRecipienter: ''
      },
      filterJson: {},
      rowData: [],
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: false,
        suppressRowSelection: false,
        context: {
          componentParent: this
        }
      },
      gridParams: {},
      gridApi: null,
      columnDefs: [
        {
          headerName: '', checkboxSelection: true, width: 70,
          sortable: false, suppressMenu: true, suppressSizeToFit: true,
          resizable: false, headerCheckboxSelection: true
        },
        { headerName: this.$t('CargoMsg.Cargo_InvoiceNo'), field: 'invoiceNo', colId: 'invoiceNo', width: 200 },
        { headerName: this.$t('CargoMsg.Cargo_InvoiceType'), field: 'invoiceType', colId: 'invoiceType', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.invoiceTypeFunc(params.value)
          } },
        { headerName: this.$t('CargoMsg.Cargo_InvoiceStatus'), field: 'invoiceState', colId: 'invoiceState', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.getInvoiceState(params.value)
          } },
        { headerName: this.$t('CargoMsg.Cargo_VoidedBy'), field: 'abandoner', colId: 'abandoner', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          } },
        { headerName: this.$t('CargoMsg.Cargo_VoidTime'), field: 'abandoningDate', colId: 'abandoningDate', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          } },

        /* RecipientsInvoiceRecords 子表数据*/
        { headerName: this.$t('CargoMsg.Cargo_Acquirer'), field: 'recipienter', colId: 'recipienter', width: 200,
          valueFormatter: (params) => {
            // 领用人
            const recipientsInvoiceRecords = params.data.recipientsInvoiceRecords || {}
            const value = recipientsInvoiceRecords.recipienter || 0
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', value, 'chineseName')
          } },
        { headerName: this.$t('CargoMsg.Cargo_AcquisitionTime'), field: 'recipientingDate', colId: 'recipientingDate', width: 200,
          valueFormatter: (params) => {
            const recipientsInvoiceRecords = params.data.recipientsInvoiceRecords || {}
            const value = recipientsInvoiceRecords.recipientingDate || ''
            return ColumnUtils.dateLabelFunc(value)
          } },

        /* PurchaseInvoiceRecords 子表数据*/
        { headerName: this.$t('CargoMsg.Cargo_PurchasedBy'), field: 'purchaser', colId: 'purchaser', width: 200,
          valueFormatter: (params) => {
            const purchaseInvoiceRecords = params.data.purchaseInvoiceRecords || {}
            const value = purchaseInvoiceRecords.purchaser || 0
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', value, 'chineseName')
          } },
        { headerName: this.$t('CargoMsg.Cargo_TimeOfPurchase'), field: 'purchasingDate', colId: 'purchasingDate', width: 200,
          valueFormatter: (params) => {
            const purchaseInvoiceRecords = params.data.purchaseInvoiceRecords || {}
            const value = purchaseInvoiceRecords.purchasingDate || ''
            return ColumnUtils.dateLabelFunc(value)
          } },

        { headerName: this.$t('CargoMsg.Cargo_User'), field: 'user', colId: 'user', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          } },
        { headerName: this.$t('CargoMsg.Cargo_TimeOfUse'), field: 'usingDate', colId: 'usingDate', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          } }],
      invoiceRecordsWindow: { // 发票领用
        visible: false,
        userAuto: 0,
        recipientingDate: ''
      },
      invoiceUserWindow: { // 发票使用
        visible: false,
        userAuto: 0,
        userDate: ''
      }
    }
  },
  computed: {
    language() {
      return this.$store.getters.language === 'zh'
    }
  },
  created() {
  },
  methods: {
    // 查询
    seachEventHandler() {
      const item = this.getCoditionObj()
      item.branchId = this.$store.getters.currentOfficeId
      this.loading = getLoading()
      console.log('item===========', item)
      const selectedStatus = recordSelectedStatus(this.gridApi, 'uuid')
      queryInvoiceNoByInvoiceNoManage({ conMap: item }).then(res => {
        this.rowData = res.data
        this.gridApi.clearFocusedCell()
        selectedStatus.revert()
      }).finally(() => {
        this.loading.close()
      })
    },
    getCoditionObj() {
      const item = {}
      // 发票号
      if (this.filter.txtInoviceNo) {
        item.inoviceNo = this.filter.txtInoviceNo
      }
      // 发票类型
      if (this.filter.invoiceType != null) {
        item.invoiceType = this.filter.invoiceType
      }
      // 发票状态
      if (this.filter.invoiceState != null) {
        item.invoiceState = this.filter.invoiceState
      }
      // 领用人
      if (this.filter.autoRecipienter) {
        item.recipienter = this.filter.autoRecipienter
      }
      // 领用时间
      if (this.filter.recipientingDateMin) {
        item.recipientingDateMin = this.filter.recipientingDateMin
      }
      if (this.filter.recipientingDateMax) {
        item.recipientingDateMax = this.filter.recipientingDateMax
      }
      // 使用人
      if (this.filter.autoUser && this.filter.autoUser > 0) {
        item.user = this.filter.autoUser
      }
      // 使用时间
      if (this.filter.usingDateMin) {
        item.usingDateMin = this.filter.usingDateMin
      }
      if (this.filter.usingDateMax) {
        item.usingDateMax = this.filter.usingDateMax
      }
      return item
    },
    // 领用 ==================================================
    recipientEventHandler() {
      const items = this.gridApi.getSelectedRows()
      if (!items || items.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectInvoiceNo'))
        return
      }
      if (this.checkInvoiceState(items)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CheckInvoiceRecipientState'))
        return
      }
      if (this.checkInvoiceType(items)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CheckInvoiceType'))
        return
      }
      this.invoiceRecordsWindow.userAuto = this.$store.getters.userId
      this.invoiceRecordsWindow.recipientingDate = new Date()
      this.invoiceRecordsWindow.visible = true
    },
    // 确认领用
    okEventRecords() {
      if (this.invoiceRecordsWindow.userAuto === 0 || (!this.invoiceRecordsWindow.userAuto && this.invoiceRecordsWindow.userAuto !== 0)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_AcquirerCanTBeEmpty'))
        return
      }
      if (!this.invoiceRecordsWindow.recipientingDate) {
        this.$message.warning(this.$t('CargoMsg.Cargo_AcquisitionTimeCanTBeEmpty'))
        return
      }
      // 获取发票UUID
      const items = this.gridApi.getSelectedRows()
      const recipientsInvoiceRecords = new RecipientsInvoiceRecords().fillDefaultValue().getData()
      recipientsInvoiceRecords.invoiceType = items[0].invoiceType
      recipientsInvoiceRecords.quantity = items.length
      recipientsInvoiceRecords.recipienter = this.invoiceRecordsWindow.userAuto
      recipientsInvoiceRecords.recipientingDate = this.invoiceRecordsWindow.recipientingDate
      recipientsInvoiceRecords.branchId = this.$store.getters.currentOfficeId
      const invoiceNos = [...items]
      if (invoiceNos && invoiceNos.length > 0) {
        for (const invoiceNo of invoiceNos) {
          invoiceNo.purchaseInvoiceRecords = []
          invoiceNo.recipientsInvoiceRecords = []
        }
      }
      recipientsInvoiceRecords.invoiceNo = invoiceNos
      this.loading = getLoading()
      saveRecipientsInvoiceRecords(recipientsInvoiceRecords).then(res => {
        if (res.data) {
          this.$message.success(this.$t('CargoMsg.Cargo_OperationSuccessfully'))
          this.seachEventHandler()
          this.invoiceRecordsWindow.visible = false
        } else {
          this.$message.error(this.$t('CargoMsg.Cargo_OperatedFailed'))
        }
      }).finally(() => {
        this.loading.close()
      })
    },
    // 是否包含未领用状态
    checkInvoiceState(items) {
      if (!items || items.length <= 0) return
      for (const item of items) {
        if (parseInt(item.invoiceState) !== 0) return true
      }
      return false
    },
    // 检查领用类型是否一致
    checkInvoiceType(items) {
      if (!items || items.length <= 0) return
      const invoiceType = items[0].invoiceType
      for (const item of items) {
        if (parseInt(item.invoiceType) !== parseInt(invoiceType)) return true
      }
      return false
    },
    // 作废 ==================================================
    invalidEventHandler() {
      const items = this.gridApi.getSelectedRows()
      if (!items || items.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectInvoiceNo'))
        return
      }
      if (this.checkInvoiceInvalidState(items)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CheckInvoiceInvalidState'))
        return
      }
      this.$confirm(this.$t('CargoMsg.Cargo_SureToVoid'), this.$t('CargoMsg.Cargo_Tips'), {
        confirmButtonText: this.$t('common.btn.yes'),
        cancelButtonText: this.$t('common.btn.no'),
        closeOnClickModal: false,
        type: 'info'
      }).then(() => {
        // for each(var c:InvoiceNo in items) {
        //   c.invoiceState = 3; //作废
        //   c.abandoner = Session.getInstance().user.userId;
        //   c.abandoningDate = new Date();
        // }
        // Session.getInstance().saveAll(new ArrayCollection(items),new Responder(delResultHandler,failedHandler),
        //   Session.getInstance().clazzAndFunctionName(this, arguments.callee, "invalidEventHandler"));
        this.loading = getLoading()
        const item = {
          invoiceState: 3 // 作废
        }
        const keys = Array.from(items, p => p.uuid)
        updateInvoiceNoFields({ conMap: item, keys: keys }).then(res => {
          this.$message.success(this.$t('CargoMsg.Cargo_InvoiceInvalidSuccessfully'))
          this.seachEventHandler()
        }).finally(() => {
          this.loading.close()
        })
      })
    },
    // 已使用和已作废的不能再次作废
    checkInvoiceInvalidState(items) {
      if (!items || items.length <= 0) return
      for (const item of items) {
        if (parseInt(item.invoiceState) === 2 || parseInt(item.invoiceState) === 3) return true
      }
      return false
    },
    // 恢复 ==================================================
    restoreEventHandler() {
      const items = this.gridApi.getSelectedRows()
      if (!items || items.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectInvoiceNo'))
        return
      }
      if (this.checkInvoiceRestoreState(items)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CheckInvoiceRestoreState'))
        return
      }
      this.$confirm(this.$t('CargoMsg.Cargo_ConfirmRestoreInvoice'), this.$t('CargoMsg.Cargo_Tips'), {
        confirmButtonText: this.$t('common.btn.yes'),
        cancelButtonText: this.$t('common.btn.no'),
        closeOnClickModal: false,
        type: 'info'
      }).then(() => {
        // for each(var c:InvoiceNo in items) {
        //   c.invoiceState = 0; //未领用
        //   c.user = 0;
        //   c.usingDate = null;
        //   c.abandoner = 0;
        //   c.abandoningDate = null;
        //   c.recipientsInvoiceRecords = null;
        // }
        // Session.getInstance().saveAll(new ArrayCollection(items),new Responder(saveRestoreInvoiceHandler,failedHandler),
        //   Session.getInstance().clazzAndFunctionName(this, arguments.callee, "restoreEventHandler"));
        this.loading = getLoading()
        const item = {
          invoiceState: 0 // 未领用
        }
        const keys = Array.from(items, p => p.uuid)
        updateInvoiceNoFields({ conMap: item, keys: keys }).then(res => {
          this.$message.success(this.$t('CargoMsg.Cargo_InvoiceRestoreSuccessfully'))
          this.seachEventHandler()
        }).finally(() => {
          this.loading.close()
        })
      })
    },
    // 是否包含不是作废状态的发票
    checkInvoiceRestoreState(items) {
      if (!items || items.length <= 0) return
      for (const item of items) {
        if (parseInt(item.invoiceState) !== 3) return true
      }
      return false
    },
    // 使用 ==================================================
    userEventHandker() {
      const selectItems = this.gridApi.getSelectedRows()
      if (!selectItems || selectItems.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CheckInvoiceUsedState'))
        return
      }
      const items = []
      for (const p of selectItems) {
        if (parseInt(p.invoiceState) === 1) {
          items.push(p)
        }
      }
      if (items.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CheckInvoiceUsedState'))
        return
      }
      this.invoiceUserWindow.userAuto = this.$store.getters.userId
      this.invoiceUserWindow.userDate = new Date()
      this.invoiceUserWindow.visible = true
    },
    // 确认使用
    okEventUser() {
      const items = this.gridApi.getSelectedRows()
      if (!items || items.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectInvoiceNo'))
        return
      }
      // var items:Array = getSelectItems();
      // for each(var c:InvoiceNo in items)
      // {
      //   c.user = userId;
      //   c.usingDate = userDate;
      //   c.invoiceState = 2; //已使用
      // }
      // Session.getInstance().saveAll(new ArrayCollection(items),new Responder(saveRecipientsHandler,failedHandler),
      //   Session.getInstance().clazzAndFunctionName(this, arguments.callee, "invoiceUserCallBackHandler"));
      if (!this.invoiceUserWindow.userAuto || this.invoiceUserWindow.userAuto === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_UserCanTBeEmpty'))
        return
      }
      if (!this.invoiceUserWindow.userDate) {
        this.$message.warning(this.$t('CargoMsg.Cargo_TimeOfUseCanTBeEmpty'))
        return
      }
      this.loading = getLoading()
      const item = {
        userId: this.invoiceUserWindow.userAuto,
        usingDate: DateUtils.formatStandardDate(this.invoiceUserWindow.userDate),
        invoiceState: 2 // 已使用
      }
      const keys = Array.from(items, p => p.uuid)
      updateInvoiceNoFields({ conMap: item, keys: keys }).then(res => {
        this.$message.success(this.$t('CargoMsg.Cargo_OperationSuccessfully'))
        this.invoiceUserWindow.visible = false
        this.seachEventHandler()
      }).finally(() => {
        this.loading.close()
      })
    },
    // 使用时间处理 =============================================================
    changeUsingDateMin() {
      if (!this.filter.usingDateMin) this.filter.usingDateMax = ''
      if (this.filter.usingDateMin && !this.filter.usingDateMax) this.filter.usingDateMax = new Date()
    },
    changeUsingDateMax() {
      if (!this.filter.usingDateMax) this.filter.usingDateMin = ''
      if (this.filter.usingDateMax && !this.filter.usingDateMin) {
        const curDate = new Date()
        this.filter.usingDateMin = new Date(curDate)
        this.filter.usingDateMin.setDate(curDate.getDate() - 7)
      }
    },
    disabledUsingDateMin(time) {
      if (!this.filter.usingDateMax) {
        // 设置可选择的日期为今天之后的6天内
        const curDate = (new Date()).getTime()
        return time.getTime() > curDate
      }
      const usingDateMax = (new Date(this.filter.usingDateMax)).getTime()
      return time.getTime() > usingDateMax
    },
    disabledUsingDateMax(time) {
      if (this.filter.usingDateMin) {
        const endDate = (new Date(this.filter.usingDateMin)).getTime()
        const dateRegion = endDate - 1 * 24 * 3600 * 1000
        return time.getTime() < dateRegion
      }
    },
    // 领用时间处理 =============================================================
    changeRecipientingDateMin() {
      if (!this.filter.recipientingDateMin) this.filter.recipientingDateMax = ''
      if (this.filter.recipientingDateMin && !this.filter.recipientingDateMax) this.filter.recipientingDateMax = new Date()
    },
    changeRecipientingDateMax() {
      if (!this.filter.recipientingDateMax) this.filter.recipientingDateMin = ''
      if (this.filter.recipientingDateMax && !this.filter.recipientingDateMin) {
        const curDate = new Date()
        this.filter.recipientingDateMin = new Date(curDate)
        this.filter.recipientingDateMin.setDate(curDate.getDate() - 7)
      }
    },
    disabledRecipientingDateMin(time) {
      if (!this.filter.recipientingDateMax) {
        // 设置可选择的日期为今天之后的6天内
        const curDate = (new Date()).getTime()
        return time.getTime() > curDate
      }
      const recipientingDateMax = (new Date(this.filter.recipientingDateMax)).getTime()
      return time.getTime() > recipientingDateMax
    },
    disabledRecipientingDateMax(time) {
      if (this.filter.recipientingDateMin) {
        const endDate = (new Date(this.filter.recipientingDateMin)).getTime()
        const dateRegion = endDate - 1 * 24 * 3600 * 1000
        return time.getTime() < dateRegion
      }
    }
  }
}
</script>

